import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Button } from 'reactstrap';
import classNames from 'classnames';
import { get, isEmpty } from 'lodash-es';
import { connect } from 'react-redux';
import { createNicePhone, clearPhone } from 'site-modules/shared/utils/phone-format';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { DealerDetailsWorkHours } from 'site-modules/dealerships/components/dealer-details-work-hours/dealer-details-work-hours';
import { DealerInfoModel } from 'client/data/models/dealer-info';
import { weekdays } from 'client/utils/weekdays';
import {
  getDealershipStateCityNameUrl,
  getDealershipWriteReviewLink,
  getDealerWebsiteExternalLink,
} from 'site-modules/shared/utils/dealership-link-constructor';
import { Link } from 'site-modules/shared/components/link/link';
import { toDisplayFormattedAddress, toQueryFormattedAddress } from 'site-modules/shared/utils/address-format';
import { MapLink } from 'site-modules/shared/components/map-link/map-link';
import { getMapSearchLinkFactory } from 'site-modules/shared/utils/map-utils';
import { ReviewsModel, ReviewsPaths } from 'client/data/models/dealer-reviews';
import { DEALER_PROPS, REVIEWS_SALES, REVIEWS_SERVICE, REVIEW_TITLE } from 'client/constants/dealer-reviews';
import { srpLinkBuilder } from 'site-modules/shared/utils/srp-link-constructor';
import { DealerReviewsOverallRating } from './dealer-review-overall-rating';

import './dealer-review-details.scss';

const PHONE_PLACEHOLDER = /1{10}/;

export class DealerDetailsUI extends Component {
  static propTypes = {
    params: DEALER_PROPS.isRequired,
    reviewType: PropTypes.string.isRequired,
    dealerInfo: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      rooftopLogicalName: PropTypes.string,
      rooftopId: PropTypes.number,
      dealerWebSites: PropTypes.arrayOf(PropTypes.string),
      workHours: PropTypes.shape({
        monday: PropTypes.shape({
          open: PropTypes.string,
          close: PropTypes.string,
        }),
        tuesday: PropTypes.shape({
          open: PropTypes.string,
          close: PropTypes.string,
        }),
        wednesday: PropTypes.shape({
          open: PropTypes.string,
          close: PropTypes.string,
        }),
        thursday: PropTypes.shape({
          open: PropTypes.string,
          close: PropTypes.string,
        }),
        friday: PropTypes.shape({
          open: PropTypes.string,
          close: PropTypes.string,
        }),
        saturday: PropTypes.shape({
          open: PropTypes.string,
          close: PropTypes.string,
        }),
        sunday: PropTypes.shape({
          open: PropTypes.string,
          close: PropTypes.string,
        }),
      }),
      phones: PropTypes.arrayOf(PropTypes.string),
      address: PropTypes.shape({
        city: PropTypes.string,
        stateCode: PropTypes.string,
        stateName: PropTypes.string,
        street: PropTypes.string,
        zip: PropTypes.string,
      }),
    }),
    dealerSmsNumber: PropTypes.string,
    isMobile: PropTypes.bool,
    overallRatingByType: PropTypes.shape({
      dealerId: PropTypes.string,
      salesReview: PropTypes.shape({
        averageRating: PropTypes.number,
        recommended: PropTypes.number,
        notRecommended: PropTypes.number,
        totalCount: PropTypes.number,
      }),
      serviceReview: PropTypes.shape({
        averageRating: PropTypes.number,
        recommended: PropTypes.number,
        notRecommended: PropTypes.number,
        totalCount: PropTypes.number,
      }),
    }),
  };

  static defaultProps = {
    dealerInfo: {
      id: null,
      name: '',
      rooftopLogicalName: '',
      rooftopId: null,
      dealerWebSites: [],
      workHours: null,
      phones: [],
      address: null,
    },
    dealerSmsNumber: '',
    isMobile: false,
    overallRatingByType: null,
  };

  /**
   * Returns dealer website link.
   * @returns {String}
   */
  getDealerWebSite = () => {
    const { dealerInfo } = this.props;
    const dealerWebSites = get(dealerInfo, 'dealerWebSites', []);
    const dealerName = get(dealerInfo, 'name', '');
    const city = get(dealerInfo, 'address.city', '');
    const stateCode = get(dealerInfo, 'address.stateCode', '');
    return getDealerWebsiteExternalLink({ dealerWebSites, dealerName, city, stateCode });
  };

  getCurrentDay = () => {
    const date = new Date();
    return weekdays[date.getDay()];
  };

  getDealerPhone = () => {
    const { phones } = this.props.dealerInfo;
    const dealerPhone = phones && phones.length && phones.find(phone => !PHONE_PLACEHOLDER.test(phone));
    return (dealerPhone && dealerPhone.replace(' ', '')) || null;
  };

  render() {
    const { params, reviewType, isMobile, dealerInfo, overallRatingByType, dealerSmsNumber } = this.props;
    const { workHours, address, name, rooftopLogicalName, rooftopId } = dealerInfo;
    const dealerWebSite = this.getDealerWebSite();
    const currentDay = this.getCurrentDay();
    const dealerPhone = this.getDealerPhone();
    const dealershipLink = getDealershipStateCityNameUrl({
      state: address.stateName,
      city: address.city,
      dealership: rooftopLogicalName,
    });
    const dealershipLinkTypeSales = getDealershipStateCityNameUrl({
      state: address.stateName,
      city: address.city,
      dealership: rooftopLogicalName,
      params: { type: 'sales' },
    });
    const dealershipLinkTypeService = getDealershipStateCityNameUrl({
      state: address.stateName,
      city: address.city,
      dealership: rooftopLogicalName,
      params: { type: 'service' },
    });
    let topLinkTitle;
    let linkType;

    if (reviewType === REVIEWS_SALES) {
      linkType = REVIEWS_SERVICE;
      topLinkTitle = REVIEW_TITLE[linkType];
    } else {
      linkType = REVIEWS_SALES;
      topLinkTitle = REVIEW_TITLE[linkType];
    }

    const topLinks = [
      {
        title: 'See all Inventory',
        url: srpLinkBuilder({
          dealerlocationid: rooftopId,
        }),
      },
      {
        title: `Write ${topLinkTitle} Review`,
        url: getDealershipWriteReviewLink({
          state: address.stateName,
          city: address.city,
          dealership: rooftopLogicalName,
          reviewType: linkType,
        }),
      },
    ];
    const overallRatingSales = get(overallRatingByType, 'salesReview');
    const overallRatingService = get(overallRatingByType, 'serviceReview');

    return (
      <Container className={classNames('dealer-details rounded p-1 p-lg-1')}>
        <Row className={classNames('top-links m-0 pb-lg-1_5')}>
          {topLinks.map(({ title, url }) => (
            <Col key={title} xs={6} md={'auto'} className={classNames('p-0 mb-1 mb-lg-0 me-md-1_5')}>
              <Link to={url} className="d-inline-block text-primary-darker">
                {title}
              </Link>
            </Col>
          ))}
        </Row>
        <hr className="m-0" />
        <Row className={classNames('pt-1 pt-lg-1_5')}>
          {address && (
            <Col md={3} xs={12}>
              {isMobile ? (
                <div className="pos-r mb-1" data-test="dealer-address">
                  <span className="icon-location5 me-0_5" aria-hidden />
                  <div className="ms-1_5">
                    <MapLink
                      location={toQueryFormattedAddress(address, name)}
                      mapLinkFactory={getMapSearchLinkFactory}
                      className="text-primary-darker"
                      target="_blank"
                    >
                      See dealer address
                    </MapLink>
                  </div>
                </div>
              ) : (
                <div className="pos-r medium mb-1" data-test="dealer-address">
                  <span className="icon-location5 me-0_5" aria-hidden />
                  <div className="ms-1_5">
                    <Link to={dealershipLink} className="text-decoration-none fw-bold text-primary-darker">
                      {name}
                    </Link>
                  </div>
                  <div className="ms-1_5">
                    {toDisplayFormattedAddress(address)} (
                    <MapLink
                      location={toQueryFormattedAddress(address, name)}
                      mapLinkFactory={getMapSearchLinkFactory}
                      className="map-link text-primary-darker"
                      target="_blank"
                    >
                      map
                    </MapLink>
                    )
                  </div>
                </div>
              )}
            </Col>
          )}
          <Col md={3} xs={12} className={classNames({ medium: !isMobile })}>
            {!isMobile && dealerPhone && (
              <div>
                <a
                  href={`tel:${clearPhone(dealerPhone)}`}
                  data-tracking-id="ddp_call_dealer"
                  className="text-gray-dark d-inline-block mb-1"
                  data-tracking-ignore-value
                >
                  <span className="icon-phone2" aria-hidden />
                  <span className="ps-0_5">{createNicePhone(dealerPhone)}</span>
                </a>
              </div>
            )}
            {dealerWebSite && (
              <div>
                <a
                  className="d-inline-block mb-1 text-gray-dark"
                  href={dealerWebSite}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                >
                  <span className="icon-open_in_new pe-0_5" aria-hidden />
                  <span className={classNames({ 'text-primary-darker': isMobile, 'text-gray-darker': !isMobile })}>
                    Visit dealer’s website&nbsp;
                  </span>
                </a>
              </div>
            )}
            {!isEmpty(workHours) && (
              <div className="mb-1 mb-lg-0">
                <span className="icon-clock float-start mb-1 mt-0_25" aria-hidden />
                <div className="text-start ms-1_5">
                  <DealerDetailsWorkHours
                    currentDay={currentDay}
                    workHours={workHours}
                    dealerZip={!!address && address.zip}
                  />
                </div>
              </div>
            )}
            {isMobile && (
              <div className="d-flex justify-content-between flex-wrap">
                {dealerSmsNumber && (
                  <Button
                    size="lg"
                    color="primary-b"
                    href={`sms:${dealerSmsNumber}`}
                    className="dealer-engagement-button py-0_75 mb-0_25 text-transform-none"
                    data-tracking-id="dealer_engagement_text"
                  >
                    <i className="icon-bubble4 me-0_5" aria-hidden />
                    <span className="fw-normal">Text us</span>
                  </Button>
                )}
                {dealerPhone && (
                  <Button
                    size="lg"
                    color="primary-b"
                    href={`tel:${clearPhone(dealerPhone)}`}
                    className="dealer-engagement-button py-0_75 mb-0_25 text-transform-none"
                    data-tracking-id="ddp_call_dealer"
                    data-tracking-ignore-value
                  >
                    <i className="icon-phone2 me-0_5" aria-hidden />
                    <span className="fw-normal">Call us</span>
                  </Button>
                )}
              </div>
            )}
            {isMobile && <hr />}
          </Col>
          <Col md={3} xs={6} className="text-gray-darker">
            <DealerReviewsOverallRating
              rating={overallRatingSales}
              reviewType={REVIEWS_SALES}
              params={params}
              dealershipLink={dealershipLinkTypeSales}
            />
          </Col>
          <Col md={3} xs={6} className="text-gray-darker">
            <DealerReviewsOverallRating
              rating={overallRatingService}
              reviewType={REVIEWS_SERVICE}
              params={params}
              dealershipLink={dealershipLinkTypeService}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

export const stateToPropsConfig = {
  dealerSmsNumber: {
    path: ({ dealerInfo, isMobile }) => {
      const rooftopId = dealerInfo && dealerInfo.rooftopId;
      return rooftopId && isMobile ? `carcodeConfig.${rooftopId}` : '';
    },
    segment: DealerInfoModel,
    transform: ({ smsNumber }) => smsNumber,
  },
  overallRatingByType: bindToPath(({ dealerInfo }) => {
    const dealerId = dealerInfo && dealerInfo.id;
    return dealerId ? ReviewsPaths.getOverallRatings({ dealerId }) : '';
  }, ReviewsModel),
};

export const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const DealerReviewDetails = connect(mapStateToProps)(connectToModel(DealerDetailsUI, stateToPropsConfig));

DealerReviewDetails.propTypes = {
  ...DealerDetailsUI.propTypes,
};
